module.exports = __webpack_public_path__ + "img/emojis_sprite.834feee.png";